import React, { ReactElement, ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSession } from 'hooks/useAuthentication';
import { Card, Col, Row, Spinner } from 'react-bootstrap';
interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { data: auth, isLoading, isFetching, error } = useSession();

  if (isLoading) {
    return (
      <div>
        <Col xs={12} className="py-4">
          <Spinner className="position-absolute start-50" animation="grow" />
        </Col>
      </div>
    ); // Replace this with your loading spinner or placeholder
  }

  if (auth?.user?.id) {
    return <Outlet />;
  } else {
    return <Navigate to="/authentication/card/login" />;
  }
};

export default ProtectedRoute;
